<template>
  <section>
    <Transition name="fade">
      <div class="tabs">
        <ul class="tabs__tab md:inline-flex">
          <li
            :class="{ 'current': activeTab === 'selectMemberships', 'disabled': activeTab !== 'selectMemberships' }"
            class="w-full md:w-auto"
          >
            <a
              id="tab-selectMemberships"
              :aria-selected="activeTab === 'selectMemberships'"
              href="#"
              v-text="'1. Select Memberships'"
            />
          </li>
          <li
            :class="{ 'current': activeTab === 'editPermissions', 'disabled': activeTab !== 'editPermissions' }"
            class="w-full md:w-auto"
          >
            <a
              id="tab-editPermissions"
              :aria-selected="activeTab === 'editPermissions'"
              href="#"
              v-text="'2. Edit Permissions'"
            />
          </li>
          <li
            :class="{ 'current': activeTab === 'confirmEdits', 'disabled': activeTab !== 'confirmEdits' }"
            class="w-full md:w-auto"
          >
            <a
              id="tab-confirmEdits"
              :aria-selected="activeTab === 'confirmEdits'"
              href="#"
              v-text="'3. Confirm Edits'"
            />
          </li>
        </ul>
        <div class="tabs__tab_content">
          <div
            v-show="activeTab === 'selectMemberships'"
            :aria-hidden="activeTab === 'selectMemberships'"
            aria-labelledby="tab-selectMemberships"
          >
            <SelectMemberships
              is="selectMemberships"
              tab-name="selectMemberships"
              @tabNavigation="handleTabNavigation"
            />
          </div>
          <div
            v-show="activeTab === 'editPermissions'"
            :aria-hidden="activeTab === 'editPermissions'"
            aria-labelledby="tab-editPermissions"
          >
            <EditPermissions
              tab-name="editPermissions"
              @permissionSelected="(payload) => edits = payload"
              @tabNavigation="handleTabNavigation"
            />
          </div>
          <div
            v-show="activeTab === 'confirmEdits'"
            :aria-hidden="activeTab === 'confirmEdits'"
            aria-labelledby="tab-confirmEdits"
          >
            <ConfirmPermissions
              :edit-target="editTarget"
              :edits="edits"
              :selected-memberships="selectedMemberships"
              tab-name="confirmEdits"
              @confirmed="handleConfirmed"
              @tabNavigation="handleTabNavigation"
            />
          </div>
        </div>
      </div>
    </Transition>
  </section>
</template>

<script type="text/babel">
import HasSelectedMemberships from 'Membership/Resources/assets/js/components/bulk-edit/mixins/HasSelectedMemberships'
import SelectMemberships from 'Membership/Resources/assets/js/components/bulk-edit/SelectMemberships'
import EditPermissions from 'Membership/Resources/assets/js/components/bulk-edit/EditPermissions'
import ConfirmPermissions from 'Membership/Resources/assets/js/components/bulk-edit/ConfirmPermissions'

export default {
  name: 'BulkPermissionsMembershipEdit',
  components: {
    SelectMemberships,
    EditPermissions,
    ConfirmPermissions,
  },
  mixins: [HasSelectedMemberships],
  props: {
    editTarget: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 'selectMemberships',
      tabOrder: [
        'selectMemberships',
        'editPermissions',
        'confirmEdits',
      ],
      edits: {},
    }
  },
  methods: {
    handleTabNavigation(payload) {
      if (this.activeTab === payload.current) {
        if (payload.direction === 'back') {
          this.activeTab = this.tabOrder[this.tabOrder.indexOf(this.activeTab) - 1]
        } else if (payload.direction === 'next') {
          this.activeTab = this.tabOrder[this.tabOrder.indexOf(this.activeTab) + 1]
        }
      }
    },
    handleConfirmed() {
      this.$api.active().post('memberships/permissions', {
        ability_ids: this.edits.ability_ids,
        role_ids: this.edits.role_ids,
        membership_ids: this.selectedMemberships.map(membership => membership.uuid),
      })
        .then(() => {
          window.location = this.$urlGenerator.active('members/' + encodeURI(`?status=Permissions stored for selected memberships`))
        })
        .catch(() => {
          this.$store.commit('baseAddNotification', {
            type: 'error',
            text: 'An error has occurred.',
            timeout: false,
          })
        })
    },
  },
}
</script>
